import { AppRoutes } from './constants'

export const showSearch = (location: string) => {
  if (
    location.includes(AppRoutes.editTemplate) ||
    location.includes(AppRoutes.contactProfile) ||
    location.includes(AppRoutes.contactProfile) ||
    location.includes(AppRoutes.settings) ||
    location.includes(AppRoutes.appointments) ||
    location.includes(AppRoutes.updateAutomationRoot) ||
    location.includes(AppRoutes.editTemplateRoot)
  ) {
    return false
  } else if (location !== AppRoutes.home) {
    return true
  }
  return false
}

export const classNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(' ')
}

export const truncate = (text: string, length: number) => {
  return text.length > length ? text.substring(0, length) + '...' : text
}
